

function Hetzner(props) {
  return (
    <div>
      hetzner
    </div>
  );
}

export default Hetzner;
